import styled from 'styled-components';
import theme from 'theme';

export const ContentSpan = styled.span`
  text-align: right;
`;

export const InlineSpan = styled.span`
  display: inline-flex;
`;
export const ButtonSpan = styled.span`
  margin-top: 2px;
`;

export const LimitedSpan = styled.span`
  color: ${theme.palette.text.primary};
  display: inline-block;
  max-width: ${theme.width.limitedSpan};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
